import Requester from "../Requester";

const paystackPaymentEndpoint = "https://api.paystack.co/transaction/initialize";

const getPaymentEndPoint = (data) => {
    return Requester.makeRequest(Requester.methods.POST, "", paystackPaymentEndpoint, data, true)
};


export default {
    payment: getPaymentEndPoint
}
